import { Col, Row } from "antd";
import { useMobileAppVersionContext } from "../../../context/MobileAppVersionContext/MobileAppVersionContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";

const ForceUpdateSettings = () => {
	const { versionData, setVersionData } = useMobileAppVersionContext();

	const handleForceUpdateChange = (checked: boolean) => {
		setVersionData({ ...versionData, forceUpdate: checked });
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<SwitchOptionComponent
						title="Force Update"
						value={versionData?.forceUpdate}
						onChange={handleForceUpdateChange}
						helperText="Bu ayar etkinleştirildiğinde, kullanıcılar uygulamayı güncellemek zorunda olacaktır."
					/>
				</Col>
			</Row>
		</>
	);
};

export default ForceUpdateSettings;
